'use strict';
const angular = require('angular');

export class galleryEmbedComponent {

  constructor($timeout, GalleryService) {
    'ngInject';

    this.$timeout = $timeout;
    this.GalleryService = GalleryService;
  }

  $onInit() {
    let METHOD = (this.public) ? "getPublic" : "get";

    this.GalleryService[METHOD]({id: this.id}, gallery => {
      this.data = gallery;

      this.galleryImages = this.data.images.map(img => {

        let imageUrl = (this.public)
          ? "/api/storage/public/" + img.image + "/ctx/" + btoa("gallery:" + this.id)
          : "/api/storage/" + img.image;

        return {
          url: imageUrl,
          //extUrl: (this.public) ? null : "/api/storage/" + img.image + "/download",
          thumbUrl: '/api/storage/' + img.image + '/thumb',
          title: img.title
        };
      });

    });
  }

  $postLink() {
    var isPublic = !!this.public;
    this.$timeout(() => {

      var working = false;

      var doApplyChanges = function() {
        if (working) return;

        working = true;
        jQuery("div.thumb").each(function() {
          var title = jQuery(this).attr('title');

          if (!isPublic) {
            let imageThumbPathCss = jQuery(this).css('background-image');
            let imageThumbPath = imageThumbPathCss.match(/\/api.*?thumb/);

            if (imageThumbPath && Array.isArray(imageThumbPath) && imageThumbPath[0]) {
              let downloadPath = imageThumbPath[0].replace('thumb','download');
              jQuery(this).append("<div class='gallery-image-inline-download-link' title='Download Image'><a target='_blank' onclick='event.stopPropagation()' href='"+downloadPath+"'><i class='fa fa-fw fa-download'></i></a></div>");
            }
          }

          if (title) {
            jQuery(this).removeAttr('title');
            jQuery(this).append("<div class='gallery-image-inline-description'>" + title + "</div>");
          }
        });
        working = false;
      };

      doApplyChanges();

      jQuery("#gallery").on('DOMSubtreeModified', (e) => {
        doApplyChanges();
      });

    },1000);
  }
}

export default angular.module('conduuApp.galleryEmbed', [])
  .component('galleryEmbed', {
    template: '<ng-image-gallery id="gallery" images="$ctrl.galleryImages" piracy="true" on-open="$ctrl.onGalleryOpen()" on-close="$ctrl.onGalleryClose()"></ng-image-gallery>',
    bindings: {
      id: '@',
      public: '@'
    },
    controller: galleryEmbedComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/gallery-embed/gallery-embed.component.js